<template>
    <div class="breadcrumb">
        <span v-if="!props.hideRoot"><AtomsGlobalLink to="/">Snubniprsteny4u.eu</AtomsGlobalLink></span>
        <span v-for="item in props.segments?.sort((a, b) => b.level - a.level)"><AtomsGlobalLink :to="item.url">{{ item.name }}</AtomsGlobalLink></span>
    </div>
</template>
<script setup>

const props = defineProps({
    segments: Array,
    hideRoot: Boolean
});

</script>
<style lang="postcss">

.breadcrumb {
    @apply text-gray;
}

.breadcrumb a:hover {
    @apply underline;
}

.breadcrumb span::after {
    content: '/';
    @apply mx-2 text-silver;
}

.breadcrumb span:last-of-type::after {
    display: none;
}

</style>